import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FloatingConsult from '@/components/feature/solution/FloatingConsult';
import ParkingHero from './components/ParkingHero';
import ParkingConcept from './components/ParkingConcept';
import ParkingPainPoints from './components/ParkingPainPoints';
import ParkingOverview from './components/ParkingOverview';
import ParkingCompare from './components/ParkingCompare';
import ParkingArchitecture from './components/ParkingArchitecture';
import ParkingProducts from './components/ParkingProducts';
import ParkingScenarios from './components/ParkingScenarios';
import ParkingFlow from './components/ParkingFlow';
import ParkingDataCenter from './components/ParkingDataCenter';
import {
  hero,
  concept,
  painPoints,
  overview,
  compare,
  architecture,
  productMatrix,
  scenes,
  flow,
  dataValue,
} from '@/mocks/smart-parking';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '自由流停车解决方案',
    serviceType: '自由流停车解决方案',
    description:
      '以融合识别、无感结算与云边端协同，实现不停车、不减速、不排队的高速、城市道路、路内泊位、停车场全场景一张网停车运营。',
    provider: {
      '@type': 'Organization',
      name: '华辉数智技术',
    },
    areaServed: '中国',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '产品与解决方案', item: 'https://www.huahui-digital.com/products' },
      { '@type': 'ListItem', position: 2, name: '解决方案', item: 'https://www.huahui-digital.com/solutions' },
      {
        '@type': 'ListItem',
        position: 3,
        name: '自由流停车',
        item: 'https://www.huahui-digital.com/solutions/smart-parking',
      },
    ],
  },
];

export default function SmartParking() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="自由流停车解决方案｜不停车通行 · 全场景一张网｜华辉数智"
        description="华辉数智自由流停车解决方案：以融合识别、无感结算与云边端协同，实现不停车、不减速、不排队的高速、城市道路、路内泊位、停车场全场景一张网停车运营。"
        keywords="自由流停车,自由流收费,无感支付,停车一张网,路内停车,无感通行,停车运营,城市停车"
        path="/solutions/smart-parking"
        jsonLd={jsonLd}
      />

      <ParkingHero data={hero} />
      <Breadcrumb
        items={[
          { label: '产品与解决方案', href: '/products' },
          { label: '解决方案', href: '/solutions' },
          { label: '自由流停车' },
        ]}
      />

      <main>
        <ParkingConcept data={concept} />
        <ParkingPainPoints data={painPoints} />
        <ParkingOverview data={overview} />
        <ParkingCompare data={compare} />
        <ParkingArchitecture data={architecture} />
        <ParkingProducts data={productMatrix} />
        <ParkingScenarios data={scenes} />
        <ParkingFlow data={flow} />
        <ParkingDataCenter data={dataValue} />
      </main>

      <Footer />
      <FloatingConsult
        accentKey="gold"
        href="/contact/business?utm_source=website&utm_medium=floating&utm_campaign=freeflow-parking"
      />
    </div>
  );
}